export default __webpack_public_path__ + "static/milestone-bg-48378c3797343524cb4f648647f39975.png";